import IconRocket3 from "./icon-rocket-3";

export default IconRocket3